import { jsonArrayMember, jsonObject } from 'typedjson';
import { PublicBoxQuestionnaireFillQuestionRequest } from './public-box-questionnaire-fill-question.request';

@jsonObject
export class PublicBoxQuestionnaireFillRequest {
  @jsonArrayMember(PublicBoxQuestionnaireFillQuestionRequest)
  public readonly questions!: PublicBoxQuestionnaireFillQuestionRequest[];

  public constructor(
    private readonly data: {
      questions: PublicBoxQuestionnaireFillQuestionRequest[];
    },
  ) {
    this.questions = this.data.questions;
  }
}
